import { FC, Fragment, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { ComponentForm, TagForm, CategoryForm } from '@/ui/components'

const Forms: FC = (): ReactNode => {
    const { Target } = SideoverState()

    return (
        <Fragment>
            {Target === 'component' && <ComponentForm />}
            {Target === 'tag' && <TagForm />}
            {Target === 'category' && <CategoryForm />}
        </Fragment>
    )
}

export default Forms
